import axios from 'axios';
import { usePersistedStore } from './store/persisted-store';
import { useGeneralStore } from './store/slices/createGeneralSlice';
import { installSentryAxiosInterceptor } from './utils/sentryAxios';

const STATIC_BUSINESS_TOKEN = "da4aa2f8-70d9-4d56-b577-3162dfae2c0f";

const axiosInstance = axios.create({

});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  function (config) {
    const TtlUpdator = usePersistedStore.getState().TtlUpdator;
    const AccessToken = usePersistedStore.getState().auth.userToken;
    const Token = usePersistedStore.getState().business.currentBusiness.token ? usePersistedStore.getState().business.currentBusiness.token : "da4aa2f8-70d9-4d56-b577-3162dfae2c0f";

    TtlUpdator()

    const isAuthEndpoint = config.url && (
      config.url.includes('/v1/authentication/') ||
      config.url.includes('/v1/authentication/login') ||
      config.url.includes('/v1/user/info')
    );

    if (isAuthEndpoint) {
      config.headers.token = STATIC_BUSINESS_TOKEN;
      if (AccessToken && !config.url.includes('/v1/authentication/')) {
        config.headers.Authorization = `Bearer ${AccessToken}`;
      }
    } else {
      config.headers.Authorization = `Bearer ${AccessToken}`;
      config.headers.token = Token;
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    const logOut = usePersistedStore.getState().logOut;
    if (error?.response) {
      if (error?.response.status < 500 && error?.response?.data?.Message) {
        useGeneralStore.getState().NotifError(error.response.data.Message, error.status)
        if (error.response.status === 401 || error.response.status === 440) {
          logOut();
        }
      }
      else {
        useGeneralStore.getState().NotifError('خطا در برقراری با سرور', error.status)
      }
    } else if (error?.status === 403) {
      if (error?.details?.Message) {
        useGeneralStore.getState().NotifError(error?.response?.data?.Message)
      }
      else {
        useGeneralStore.getState().NotifError("لطفا برای ادامه ی خرید VPN خود را خاموش کنید", error?.status);
      }
    } else if (error?.message === "Network Error") {
      useGeneralStore.getState().NotifError("خطا در برقراری ارتباط با سرور. لطفا اتصال اینترنت خود را بررسی کنید")
    } else {
      useGeneralStore.getState().NotifError(`خطایی رخ داده است  ${error.status}`)
    }
    return Promise.reject(error)
  }
);

installSentryAxiosInterceptor(axiosInstance);

export default axiosInstance;
